export default __webpack_public_path__ + "assets/images/coin.023ae9.webp";